export type FieldKind = 'year' | 'sheet' | 'ring' | 'name' | 'plumage' | 'sex' | 'observations'

const plumageTerms = [
  'Gabino', 'Gavino', 'Toscado', 'Toscada', 'Moscado', 'Moscada', 'Moracho', 'Moracha',
  'Mascarado', 'Mascarada', 'Bayo', 'Baya', 'Ahumado', 'Ahumada', 'Tenado', 'Tenada',
  'Azul Curro', 'Gabino Blanco', 'Gavino Blanco'
]

export function normalizeOcrValue(value: string) {
  return value.replace(/[|]/g, 'I').replace(/\s+/g, ' ').trim()
}

export function validateField(kind: FieldKind, raw: string) {
  const value = normalizeOcrValue(raw)
  if (!value) return { valid: false, value, reason: 'No se ha podido leer' }
  if (kind === 'ring') {
    if (/[^A-Za-z0-9\s-]/.test(value)) return { valid: false, value, reason: 'La anilla contiene caracteres dudosos' }
    const compact = value.toUpperCase().replace(/[^A-Z0-9]/g, '')
    const match = compact.match(/^([A-Z]{1,3})(\d{4,8})$/)
    return match
      ? { valid: true, value: `${match[1]}-${match[2]}` }
      : { valid: false, value, reason: 'Formato de anilla no válido' }
  }
  if (kind === 'year') {
    const match = value.match(/(?:19|20)\d{2}/)
    const year = match ? Number(match[0]) : 0
    return year >= 1900 && year <= new Date().getFullYear() + 1
      ? { valid: true, value: String(year) }
      : { valid: false, value, reason: 'Año fuera de rango' }
  }
  if (kind === 'sheet') {
    const match = value.match(/\d{1,4}/)
    const sheet = match ? Number(match[0]) : 0
    return sheet > 0 && sheet < 10000
      ? { valid: true, value: String(sheet) }
      : { valid: false, value, reason: 'Número de hoja no válido' }
  }
  if (kind === 'sex') {
    const lower = value.toLocaleLowerCase('es')
    if (value === '♂' || /\b(m|macho|masculino)\b/.test(lower)) return { valid: true, value: 'MACHO' }
    if (value === '♀' || /\b(h|hembra|femenino)\b/.test(lower)) return { valid: true, value: 'HEMBRA' }
    return { valid: false, value, reason: 'Sexo no reconocido' }
  }
  if (kind === 'plumage') {
    const exact = plumageTerms.find(term => term.toLocaleLowerCase('es') === value.toLocaleLowerCase('es'))
    return exact
      ? { valid: true, value }
      : { valid: false, value, reason: 'Plumaje fuera del vocabulario conocido; revisar sin corregir' }
  }
  return { valid: value.length >= 2, value, reason: value.length >= 2 ? undefined : 'Texto demasiado corto' }
}

export function minimumConfidence(kind: FieldKind) {
  if (kind === 'ring') return 82
  if (kind === 'year' || kind === 'sheet' || kind === 'sex') return 76
  if (kind === 'name' || kind === 'observations') return 80
  return 74
}

export function fieldCategory(path: string): FieldKind {
  if (path === 'anio') return 'year'
  if (path === 'hoja') return 'sheet'
  if (path.endsWith('.anilla')) return 'ring'
  if (path.endsWith('.nombre')) return 'name'
  if (path.endsWith('.plumaje')) return 'plumage'
  if (path.endsWith('.sexo')) return 'sex'
  return 'observations'
}
